<script lang="ts">
	//Stores
		import { readDeviceSettings, readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Types
	import type { ExtendEditableObject } from 'src/types/EditableObject';
	//Services
	import { format } from 'svelte-i18n';
	//Svelte hooks
	import { beforeUpdate, onDestroy } from 'svelte';
	//Helpers
	import { get_mode, real_id } from '../../helpers/interface_helpers';
	import { capFirstChar } from '../../helpers/utilities';
	//Components
	import WizardWrapperEditableObject from '../ModalWizzard/WizardWrapperEditableObject.svelte';
	// import QuickActions from './Steps/QuickActions.svelte';
	//Templates
	import { trvTemplate } from './Templates/trvTemplate';
	import { motionTemplate } from './Templates/motionTemplate';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let showModal, deviceActions: ExtendEditableObject;
	const device = deviceActions.device;

	const id = real_id(device.id);
	const mode = get_mode(device, readDeviceStatus(id), readDeviceSettings(id));
	const isThermostat = mode === 'thermostat';
	const templates = {
		thermostat: trvTemplate,
		sensor: motionTemplate,
	};
	let validation = {
		0: { disabled: false },
		1: { disabled: false },
		2: { disabled: false },
		3: { disabled: false },
	};
	$: windowReport = deviceActions?.condition === deviceActions?.options?.[0];

	$: wizardItems = templates[mode](
		deviceActions.disabled,
		deviceActions,
		windowReport,
		deviceActions.activeIndex,
	);

	beforeUpdate(() => {
		const _items = wizardItems;
		_items.forEach((item, index) => {
			validation[index].disabled = wizardItems?.[index]?.validation;
			item.disabled = validation?.[item.activeIndex]?.disabled;

			if (isThermostat) {
				if (!windowReport) {
					validation[index].disabled = false;
				}
			}
		});
		wizardItems = _items;
	});

	onDestroy(() => {
		//Clear editable object
		deviceActions.activeIndex = 0;
		// 	deviceActions.selectedDevices = [];
		deviceActions.condition = deviceActions.options[0];
	});
</script>

<!-- DO NOT REMOVE COMMENT: Padding references -->
<WizardWrapperEditableObject
	wizardContentClasses={classMap({
		'pb-s': (deviceActions.activeIndex !== 2 && mode === 'sensor') || mode === 'thermostat',
		'pl-0 pr-0': deviceActions.activeIndex === 2 && mode === 'sensor',
	})}
	title={capFirstChar($format('quick_actions'))}
	callback={deviceActions.callback}
	bind:editableObject={deviceActions}
	disabled={deviceActions.disabled}
	bind:showModal
	bind:wizardItems
	bind:validation
	wrapWithContainer={false}
	fromQuickActions
/>
